import {IconDatabase, IconFileInvoice, IconTruck, IconUser} from "@tabler/icons-react";
import {PageActionDef} from "./page-action-def";

export const otsPageActions: PageActionDef[] = [
  {
    id: "abac-policies",
    path: "/abac-policies",
    title: {
      id: "common.entity.abacpolicy.plural",
      defaultMessage: "ABAC Policies",
    },
    description: {
      id: "common.action.view.entity.abacpolicy.plural",
      defaultMessage: "View ABAC Policies",
    },
    keywords: ["view", "abac", "policy", "policies"],
    access: "abacpolicy_view",
    group: "security",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "companies",
    path: "/companies",
    title: {
      id: "common.entity.company.plural",
      defaultMessage: "Companies",
    },
    description: {
      id: "common.action.view.entity.company.plural",
      defaultMessage: "View Companies",
    },
    keywords: ["view", "company", "companies"],
    access: "company_view",
    group: "master-data",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "containers",
    path: "/containers",
    title: {
      id: "common.entity.container.plural",
      defaultMessage: "Containers",
    },
    description: {
      id: "common.action.view.entity.container.plural",
      defaultMessage: "View Containers",
    },
    keywords: ["view", "container"],
    access: "container_view",
    group: "assets",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "container-clusters",
    path: "/container-clusters",
    title: {
      id: "common.entity.containercluster.plural",
      defaultMessage: "Container Clusters",
    },
    description: {
      id: "common.action.view.entity.containercluster.plural",
      defaultMessage: "View Container Clusters",
    },
    keywords: ["view", "container", "cluster", "commingled"],
    access: "containerCluster_view",
    group: "assets",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "custom-field-defs",
    path: "/custom-field-defs",
    title: {
      id: "common.entity.customfielddef.plural",
      defaultMessage: "Custom Field Definitions",
    },
    description: {
      id: "common.action.view.entity.customfielddef.plural",
      defaultMessage: "View Custom Field Definitions",
    },
    keywords: ["view", "custom", "field", "def"],
    access: "customfielddef_view",
    group: "configuration",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "custom-field-profiles",
    path: "/custom-field-profiles",
    title: {
      id: "common.entity.customfieldprofile.plural",
      defaultMessage: "Custom Field Profiles",
    },
    description: {
      id: "common.action.view.entity.customfieldprofile.plural",
      defaultMessage: "View Custom Field Profiles",
    },
    keywords: ["view", "custom", "field", "profile"],
    access: "customfieldprofile_view",
    group: "configuration",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "geofence-site-groups",
    path: "/geofence-site-groups",
    title: {
      id: "common.entity.geofencesitegroup.plural",
      defaultMessage: "Geofence Site Groups",
    },
    description: {
      id: "common.action.view.entity.geofencesitegroup.plural",
      defaultMessage: "View Geofence Site Groups",
    },
    keywords: ["view", "geofence", "site", "group"],
    access: "geofencesitegroup_view",
    group: "locations",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "invoices",
    path: "/financial/invoices",
    title: {
      id: "common.entity.invoice.plural",
      defaultMessage: "Invoices",
    },
    description: {
      id: "common.action.view.entity.invoice.plural",
      defaultMessage: "View Invoices",
    },
    keywords: ["view", "invoice"],
    access: "invoice_view",
    group: "financial",
    icon: {
      library: "tabler",
      component: IconFileInvoice,
    },
  },
  {
    id: "meters",
    path: "/meters",
    title: {
      id: "common.entity.meter.plural",
      defaultMessage: "Meters",
    },
    description: {
      id: "common.action.view.entity.meter.plural",
      defaultMessage: "View Meters",
    },
    keywords: ["view", "meter"],
    access: "meter_view",
    group: "assets",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "notification-subscriptions",
    path: "/notifications",
    title: {
      id: "common.entity.notificationsubscription.plural",
      defaultMessage: "Notification Subscriptions",
    },
    description: {
      id: "common.action.view.entity.notificationsubscription.plural",
      defaultMessage: "View Notification Subscriptions",
    },
    keywords: ["view", "notification", "subscription"],
    group: "notifications",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "notification-receiver-profiles",
    path: "/notifications/receiver-profiles",
    title: {
      id: "common.entity.notificationreceiverprofile.plural",
      defaultMessage: "Notification Receiver Profiles",
    },
    description: {
      id: "common.action.view.entity.notificationreceiverprofile.plural",
      defaultMessage: "View Notification Receiver Profiles",
    },
    keywords: ["view", "notification", "receiver", "profile"],
    access: "notificationreceiverprofile_view",
    group: "notifications",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "notification-sender-profiles",
    path: "/notifications/sender-profiles",
    title: {
      id: "common.entity.notificationsenderprofile.plural",
      defaultMessage: "Notification Sender Profiles",
    },
    description: {
      id: "common.action.view.entity.notificationsenderprofile.plural",
      defaultMessage: "View Notification Sender Profiles",
    },
    keywords: ["view", "notification", "sender", "profile"],
    access: "notificationsenderprofile_view",
    group: "notifications",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "notification-templates",
    path: "/notifications/templates",
    title: {
      id: "common.entity.notificationtemplate.plural",
      defaultMessage: "Notification Templates",
    },
    description: {
      id: "common.action.view.entity.notificationtemplate.plural",
      defaultMessage: "View Notification Templates",
    },
    keywords: ["view", "notification", "template"],
    access: "notificationtemplate_view",
    group: "notifications",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "operating-areas",
    path: "/operating-areas",
    title: {
      id: "common.entity.operatingarea.plural",
      defaultMessage: "Operating Areas",
    },
    description: {
      id: "common.action.view.entity.operatingarea.plural",
      defaultMessage: "View Operating Areas",
    },
    keywords: ["view", "operating", "operation", "operational", "area"],
    access: "operatingarea_view",
    group: "locations",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "permissions",
    path: "/permissions",
    title: {
      id: "common.entity.permission.plural",
      defaultMessage: "Permissions",
    },
    description: {
      id: "common.action.view.entity.permission.plural",
      defaultMessage: "View Permissions",
    },
    keywords: ["view", "permission", "permissions"],
    access: "permission_view",
    group: "security",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "pipelines",
    path: "/pipelines/data",
    title: {
      id: "common.entity.pipeline.plural",
      defaultMessage: "Pipelines",
    },
    description: {
      id: "common.action.view.entity.pipeline.plural",
      defaultMessage: "View Pipelines",
    },
    keywords: ["view", "pipeline", "flow"],
    access: "pipeline_view",
    group: "pipelines",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "pipeline-flows",
    path: "/pipelines/flows",
    title: {
      id: "common.entity.pipelineflow.plural",
      defaultMessage: "Flow Volumes",
    },
    description: {
      id: "common.action.view.entity.pipelineflow.plural",
      defaultMessage: "View Flow Volumes",
    },
    keywords: ["view", "pipeline", "flow", "volume"],
    access: "pipelineFlow_view",
    group: "pipelines",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "pipeline-flow-tickets",
    path: "/pipelines/flow-tickets",
    title: {
      id: "common.entity.pipelineflowtransport.plural",
      defaultMessage: "Flow Tickets",
    },
    description: {
      id: "common.action.view.entity.pipelineflowtransport.plural",
      defaultMessage: "View Flow Tickets",
    },
    keywords: ["view", "pipeline", "flow", "ticket"],
    access: "pipelineFlowTransport_view",
    group: "pipelines",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "production-volumes",
    path: "/production-volumes",
    title: {
      id: "common.entity.productionvolume.plural",
      defaultMessage: "Production Volumes",
    },
    description: {
      id: "common.action.view.entity.productionvolume.plural",
      defaultMessage: "View Production Volumes",
    },
    keywords: ["view", "production", "volume"],
    access: "productionVolume_view",
    group: "production",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "roles",
    path: "/roles",
    title: {
      id: "common.entity.role.plural",
      defaultMessage: "Roles",
    },
    description: {
      id: "common.action.view.entity.role.plural",
      defaultMessage: "View Roles",
    },
    keywords: ["view", "role", "roles"],
    access: "role_view",
    group: "security",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "restrictions",
    path: "/restrictions",
    title: {
      id: "common.entity.restriction.plural",
      defaultMessage: "Restrictions",
    },
    description: {
      id: "common.action.view.entity.restriction.plural",
      defaultMessage: "View Restrictions",
    },
    keywords: ["view", "restriction", "restrictions"],
    access: "restriction_view",
    group: "security",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "routes",
    path: "/routes",
    title: {
      id: "common.entity.route.plural",
      defaultMessage: "Routes",
    },
    description: {
      id: "common.action.view.entity.route.plural",
      defaultMessage: "View Routes",
    },
    keywords: ["view", "route"],
    access: "route_view",
    group: "routing",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "service-events",
    path: "/service-events",
    title: {
      id: "common.entity.serviceevent.plural",
      defaultMessage: "Service Events",
    },
    description: {
      id: "common.action.view.entity.serviceevent.plural",
      defaultMessage: "View Service Events",
    },
    keywords: ["view", "service", "events"],
    access: "serviceevent_view",
    group: "operations",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "service-event-ticket-policies",
    path: "/service-event-ticket-policies",
    title: {
      id: "common.entity.serviceeventticketpolicy.plural",
      defaultMessage: "Service Event Ticket Policies",
    },
    description: {
      id: "common.action.view.entity.serviceeventticketpolicy.plural",
      defaultMessage: "View Service Event Ticket Policies",
    },
    keywords: ["view", "service", "events", "ticket", "policy", "policies"],
    access: "serviceeventticketpolicy_view",
    group: "operations",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "service-types",
    path: "/service-types",
    title: {
      id: "common.entity.servicetype.plural",
      defaultMessage: "Service Types",
    },
    description: {
      id: "common.action.view.entity.servicetype.plural",
      defaultMessage: "View Service Types",
    },
    keywords: ["view", "service", "type"],
    access: "servicetype_view",
    group: "configuration",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "sites",
    path: "/sites",
    title: {
      id: "common.entity.site.plural",
      defaultMessage: "Sites",
    },
    description: {
      id: "common.action.view.entity.site.plural",
      defaultMessage: "View Sites",
    },
    keywords: ["view", "site", "sites"],
    access: "site_view",
    group: "locations",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "site-mileages",
    path: "/sites/mileages",
    title: {
      id: "common.entity.site.mileage.plural",
      defaultMessage: "Site Mileages",
    },
    description: {
      id: "common.action.view.entity.site.mileage.plural",
      defaultMessage: "View Site Mileages",
    },
    keywords: ["view", "site", "sites", "mileage", "mileages"],
    access: "site_view",
    group: "locations",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "tag-categories",
    path: "/tags/categories",
    title: {
      id: "common.entity.tagcategory.plural",
      defaultMessage: "Tag Categories",
    },
    description: {
      id: "common.action.view.entity.tagcategory.plural",
      defaultMessage: "View Tag Categories",
    },
    keywords: ["view", "tag", "tags", "category", "categories"],
    access: "tagcategory_view",
    group: "master-data",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "tag-definitions",
    path: "/tags/definitions",
    title: {
      id: "common.entity.tagdefinition.plural",
      defaultMessage: "Tag Definitions",
    },
    description: {
      id: "common.action.view.entity.tagdefinition.plural",
      defaultMessage: "View Tag Definitions",
    },
    keywords: ["view", "tag", "tags", "definition", "definitions"],
    access: "tagdefinition_view",
    group: "master-data",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "wells",
    path: "/wells",
    title: {
      id: "common.entity.well.plural",
      defaultMessage: "Wells",
    },
    description: {
      id: "common.action.view.entity.well.plural",
      defaultMessage: "View Wells",
    },
    keywords: ["view", "well"],
    access: "well_view",
    group: "locations",
    icon: {
      library: "tabler",
      component: IconDatabase,
    },
  },
  {
    id: "trailers",
    path: "/trailers",
    title: {
      id: "common.entity.trailer.plural",
      defaultMessage: "Trailers",
    },
    description: {
      id: "common.action.view.entity.trailer.plural",
      defaultMessage: "View Trailers",
    },
    keywords: ["view", "trailer"],
    access: "trailer_view",
    group: "assets",
    icon: {
      library: "tabler",
      component: IconTruck,
    },
  },
  {
    id: "vehicles",
    path: "/vehicles",
    title: {
      id: "common.entity.vehicle.plural",
      defaultMessage: "Vehicles",
    },
    description: {
      id: "common.action.view.entity.vehicle.plural",
      defaultMessage: "View Vehicles",
    },
    keywords: ["view", "vehicle", "truck"],
    access: "vehicle_view",
    group: "assets",
    icon: {
      library: "tabler",
      component: IconTruck,
    },
  },
  {
    id: "persons",
    path: "/persons",
    title: {
      id: "common.entity.person.alt.plural",
      defaultMessage: "Users",
    },
    description: {
      id: "common.action.view.entity.person.alt.plural",
      defaultMessage: "View Users",
    },
    keywords: ["view", "person", "driver", "user"],
    access: "person_view",
    group: "people",
    icon: {
      library: "tabler",
      component: IconUser,
    },
  },
];
